export enum ListHeadType {
  Discussion = 'Discussion',
  Collaboration = 'Collaboration',
  Event = 'Event',
  Members = 'Members',
}
